import { render, staticRenderFns } from "./currency-input.vue?vue&type=template&id=79ba8e9e&scoped=true&"
import script from "./currency-input.vue?vue&type=script&lang=ts&"
export * from "./currency-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ba8e9e",
  null
  
)

export default component.exports